<template>
  <b-modal size="lg" id="financial-modal" title="New Financial" @hidden="resetForm" @shown="checkFinancial" hide-footer>
    <div class="text-right">
      <userpilot-flow :id="'1670346233aPqx942'" :variant="'outline-primary'"></userpilot-flow>
    </div>
    <validation-observer v-slot="{handleSubmit}" ref="formValidator">
      <form class="needs-validation"
            @submit.prevent="handleSubmit(submit)">
        <b-row>
          <b-col md="6">
            <base-input label="Date:" label-for="date">
              <b-form-datepicker v-model="form.date" required placeholder="Choose a date" local="en"></b-form-datepicker>
            </base-input>
          </b-col>
          <b-col md="6">
            <base-input label="Type:" rules="required" name="Type">
              <el-select v-model="form.type" placeholder="Select a Type">
                <el-option value="expense" label="Expense"></el-option>
                <el-option value="revenue" label="Revenue"></el-option>
              </el-select>
            </base-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <base-input label="Description:"
                        rules="required"
                        name="Description"
                        prependIcon="fas fa-file"
                        v-model="form.description"
                        placeholder="Office Lease">
            </base-input>
          </b-col>
          <b-col md="6">
            <base-input label="Amount:"
                        type="number"
                        min="0.01"
                        step="0.01"
                        rules="required"
                        name="Amount"
                        prependIcon="fas fa-dollar-sign"
                        v-model="form.amount"
                        placeholder="0">
            </base-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <base-input label="Account:"
                        rules="required"
                        name="Account"
                        prependIcon="fas fa-credit-card"
                        v-model="form.account_used"
                        placeholder="Visa Credit Card">
            </base-input>
          </b-col>
          <b-col md="6">
            <base-input label="Category:" rules="required" name="Category">
              <el-select v-model="form.category" placeholder="Select a Category">
                <el-option v-for="category in categories"
                           :key="category"
                           :label="category"
                           :value="category">
                </el-option>
              </el-select>
            </base-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <base-input label="Associated Lead Source:">
              <el-select v-model="form.primary_source"
                         filterable
                         placeholder="Type or Select a Lead Source">
                <el-option v-for="(source, key) in primarySources"
                           :key="source"
                           :label="source"
                           :value="source">
                </el-option>
              </el-select>
            </base-input>
          </b-col>
          <b-col md="6">
            <label class="form-control-label">Include in Profit & Loss:</label>
            <div>
              <b-form-radio-group v-model="form.confirmed" name="confirmed" button-variant="outline-danger" buttons>
                <b-form-radio :value="false" name="false">No</b-form-radio>
                <b-form-radio :value="true" name="true">Yes</b-form-radio>
              </b-form-radio-group>
            </div>
          </b-col>
          <b-col md="6">
            <label class="form-control-label">Recurring:</label>
            <div>
              <b-form-radio-group :class="form.recurring ? 'mb-1' : 'mb-3'" v-model="form.recurring" name="recurring" button-variant="outline-danger" buttons>
                <b-form-radio :value="false" name="false">No</b-form-radio>
                <b-form-radio :value="true" name="true">Yes</b-form-radio>
              </b-form-radio-group>
              <p class="small text-danger" v-if="form.recurring"><em>Recurring financials will be automatically generated monthly.</em></p>
            </div>
          </b-col>
        </b-row>
        <base-button block type="success" native-type="submit">
          <span v-if="id">Update</span>
          <span v-else>Submit</span>
        </base-button>
      </form>
    </validation-observer>
  </b-modal>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import {Select, Option} from 'element-ui';
import expensesMixin from '@/mixins/expenses-mixin';
import sourcesMixin from '@/mixins/sources-mixin';
import UserpilotFlow from '@/views/Components/UserpilotFlow';

export default {
  mixins: [expensesMixin, sourcesMixin],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    UserpilotFlow
  },
  props: {
    userRoute: null,
    financial: null
  },
  data() {
    return {
      id: null,
      form: {
        date: new Date(),
        type: 'expense',
        description: '',
        amount: '',
        account_used: '',
        category: '',
        primary_source: '',
        recurring: false,
        confirmed: true
      },
      expenseTypes: [],
      incomeTypes: []
    }
  },
  computed: {
    categories() {
      if (this.form.type == 'expense') {
        return this.expenseTypes;
      } else {
        return this.incomeTypes;
      }
    }
  },
  methods: {
    submit() {
      if(this.id) {
        this.handleUpdate();
      } else {
        this.handleCreate();
      }
    },
    handleCreate() {
      axios.post(this.userRoute + "/expenses", this.form)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.$emit('getExpenses');
          this.$refs.formValidator.reset();
          this.$bvModal.hide('financial-modal');
        });
      })
      .catch(error => {
        // error
      });
    },
    handleUpdate() {
      axios.patch(this.userRoute + "/expenses/" + this.id, {
        date: this.form.date,
        description: this.form.description,
        amount: this.form.amount,
        account_used: this.form.account_used,
        category: this.form.category,
        primary_source: this.form.primary_source,
        recurring: this.form.recurring,
        confirmed: this.form.confirmed,
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.$emit('getExpenses');
          this.$refs.formValidator.reset();
          this.$bvModal.hide('financial-modal');
        });
      })
      .catch(error => {
        // error
      });
    },
    startWalkthrough(id) {
      userpilot.trigger(id);
    },
    checkFinancial() {
      if(this.financial) {
        this.id = this.financial.id;
        this.form.date = this.financial.date;
        this.form.type = this.financial.type;
        this.form.description = this.financial.description;
        this.form.amount = this.financial.amount;
        this.form.account_used = this.financial.account_used;
        this.form.category = this.financial.category;
        this.form.primary_source = this.financial.primary_source;
        this.form.recurring = this.financial.recurring;
        this.form.confirmed = this.financial.confirmed;
      }
    }
  },
  created() {
    this.getExpenseTypes();
    this.getIncomeTypes();
  }
};
</script>